import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Loading from '../Loading';
import { styles } from '../../styles/chart-panel-styles';
import * as utils from './utils';
import GridPanel from './GridPanel';
import SlideshowPanel from './SlideshowPanel';

class ChartPanel extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      isMounted: false,
      playAlarm: false
    }
  }
  alarm = new Audio("../sounds/alarm.mp3");
  componentDidMount() {
    this.setState({
      playAlarm: true
    })
    if(this.props.layout === "slideshow") {
      this.props.resizeHeight(0.23);
    }
  }
  componentDidUpdate(prevProps) {
    if(prevProps.layout !== this.props.layout) {
      if(this.props.layout === "slideshow") {
        this.props.resizeHeight(0.23);
      } else {
        this.props.resizeHeight(0.15);
      }
    }
  }
  render() {
    const { classes } = this.props;
    let chartCards = <Loading />;
    if(this.props.data.length != 0) {
      let chartCardsArray = utils.buildChartCards(12/this.props.cols, this.props, this.props.data);
      const chartCardsDisplay = chartCardsArray.map(chartCard => {
        return chartCard.element;
      })
      switch(this.props.layout) {
      case "slideshow":
        chartCardsArray = utils.buildChartCards(6, this.props, this.props.data);
        chartCards = <SlideshowPanel cards={chartCardsDisplay} />
        break;
      default:
        chartCards = <GridPanel cards={chartCardsDisplay} />;
      }
    }
    return (
      <div>
        {chartCards}
      </div>  
    )
  }
}

ChartPanel.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(ChartPanel);



// WEBPACK FOOTER //
// ./src/components/ChartPanel/ChartPanel.js